import { useContext, useEffect, useRef, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import "./Chart.scss";
import { authContext } from "../Context/Authentication/authContext";

am4core.addLicense("CH332271218");

am4core.useTheme(am4themes_animated);

const randColor = () => {
  return "#f7b047";
  // (
  //   "#" +
  //   Math.floor(Math.random() * 16777215)
  //     .toString(16)
  //     .padStart(6, "0")
  //     .toUpperCase()
  // );
};

const Chart = ({
  chartData,
  city,
  title,
  zipcode,
  showInterval,
  indicators,
}: any) => {
  const chartRef: any = useRef(null);
  const [cities, setCities]: any = useState([]);
  const { state }: any = useContext(authContext);

  useEffect(() => {
    chartRef.current = am4core.create("chartDiv", am4charts.XYChart);
    chartRef.current.data = chartData;

    // Set input format for the dates
    chartRef.current.dateFormatter.inputDateFormat = "yyyy-MM-dd";
    if (title !== "Population" && title !== "Scale") {
      chartRef.current.events.on("ready", function () {
        dateAxis.zoomToDates(new Date(2022, 1, 1), new Date());
      });
    }
    if (title === "Scale") {
      chartRef.current.events.on("ready", function () {
        dateAxis.zoomToDates(
          new Date(state.filters.economicYears[1] + 2000 - 1, 1, 1),
          new Date(state.filters.economicYears[1] + 2000, 12, 1)
        );
      });
    }
    // Create axes
    const dateAxis = chartRef.current.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.strokeWidth = 1;
    dateAxis.renderer.grid.template.strokeOpacity = 0.3;
    dateAxis.renderer.grid.template.stroke = "#fff";
    dateAxis.renderer.minGridDistance = 100;
    dateAxis.title.text = "Date";
    dateAxis.title.fill = "#fff";
    dateAxis.title.fontSize = 13;
    dateAxis.renderer.labels.template.fontSize = 10;
    dateAxis.title.fontWeight = "bold";
    dateAxis.dateFormats.setKey("month", "MMM YYYY");
    dateAxis.renderer.labels.template.fill = "#fff";

    const valueAxis = chartRef.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.stroke = "#fff";
    valueAxis.renderer.grid.template.strokeWidth = 1;
    valueAxis.renderer.grid.template.strokeOpacity = 0.3;
    valueAxis.title.text = title;
    valueAxis.title.fill = "#fff";
    valueAxis.title.fontSize = 13;
    valueAxis.title.fontWeight = "bold";
    valueAxis.renderer.labels.template.fontSize = 10;
    valueAxis.renderer.labels.template.fill = "#fff";

    // Create series
    let cityData: any = [];

    const createSeries = (value: any, color: string, item: string) => {
      if (title === "Scale") {
        indicators.forEach((val: any) => {
          if (val === item) {
            cityData.push({
              name: val,
              color: color,
            });
          }
        });
      } else if (showInterval) {
        cityData.push({
          name: item,
          color: color,
        });
      } else {
        (zipcode?.length ? zipcode : city).forEach((val: any) => {
          if (val === item) {
            cityData.push({
              name: val,
              color: color,
            });
          }
        });
      }
      setCities(cityData);
      const series = chartRef.current.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = value;
      series.dataFields.dateX = "date";
      series.strokeWidth = 2;
      series.dataItems.template.locations.dateX = 0;
      series.stroke = am4core.color(color);
      series.tooltipHTML = `<div><div><span style="font-weight: bold">${
        showInterval
          ? value === "value1"
            ? `${zipcode[0] ? zipcode[0] : city[0]} High`
            : value === "value2"
            ? `${zipcode[0] ? zipcode[0] : city[0]} Mean`
            : value === "value3"
            ? `${zipcode[0] ? zipcode[0] : city[0]} Low`
            : ""
          : title
      }:</span> {valueY}</div><div><span style="font-weight: bold">Date:</span> {dateX}</div></div>`;
      series.tooltip.label.minWidth = 40;
      series.tooltip.label.minHeight = 40;
      series.tooltip.label.textAlign = "middle";
      series.tooltip.label.textValign = "middle";
      // series.tooltip.label.backgroundColor = color;
      // series.tooltip.label.color = "#fff";
      series.tooltip.label.fontSize = 10;
      series.sequencedInterpolation = true;
      series.hoverOnFocus = true;

      const bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.circle.strokeWidth = 1;
      bullet.circle.radius = 3;
      bullet.circle.fill = am4core.color(color);
      bullet.tooltipHTML = `<div><div><span style="font-weight: bold">${
        showInterval
          ? value === "value1"
            ? `${zipcode[0] ? zipcode[0] : city[0]} High`
            : value === "value2"
            ? `${zipcode[0] ? zipcode[0] : city[0]} Low`
            : value === "value3"
            ? `${zipcode[0] ? zipcode[0] : city[0]} Mean`
            : ""
          : title
      }:</span> {valueY}</div><div><span style="font-weight: bold">${
        zipcode && zipcode[0] ? "Zipcode" : "City"
      }:</span> ${item}</div><div><span style="font-weight: bold">Date:</span> {dateX}</div></div>`;

      if (title !== "Scale" && title !== "Population") {
        let range = dateAxis.createSeriesRange(series);
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() - 2;
        range.date = new Date(year, month, 1)
        range.endDate = new Date(2028, 1, 1);
        range.contents.strokeDasharray = "3, 3";
      }

      var scrollbarX = new am4charts.XYChartScrollbar();
      scrollbarX.background.fill = am4core.color("#fff");
      scrollbarX.background.fillOpacity = 0.2;
      scrollbarX.startGrip.icon.stroke = am4core.color("#fff");
      scrollbarX.endGrip.icon.stroke = am4core.color("#fff");

      scrollbarX.series.push(series);
      chartRef.current.scrollbarX = scrollbarX;
      chartRef.current.scrollbarX.parent = chartRef.current.bottomAxesContainer;
      chartRef.current.scrollbarX.startGrip.background.states.getKey(
        "hover"
      ).properties.fill = am4core.color("#fff");
      chartRef.current.scrollbarX.endGrip.background.states.getKey(
        "hover"
      ).properties.fill = am4core.color("#fff");
      chartRef.current.scrollbarX.startGrip.background.fill =
        am4core.color("#F7B047");
      chartRef.current.scrollbarX.endGrip.background.fill =
        am4core.color("#F7B047");
      chartRef.current.scrollbarX.thumb.background.fill =
        am4core.color("#171d25");
      let scrollSeries =
        chartRef.current.scrollbarX.scrollbarChart.series.getIndex(0);
      scrollSeries.stroke = "#000";
      chartRef.current.scrollbarX.background.fill = am4core.color("#fff");
      chartRef.current.scrollbarX.background.fillOpacity = 0.2;
      chartRef.current.scrollbarX.unselectedOverlay.fill =
        am4core.color("#fff");
      chartRef.current.scrollbarX.unselectedOverlay.fillOpacity = 0.5;
      return series;
    };

    if (title === "Scale") {
      indicators?.forEach((item: any, i: number) => {
        createSeries(`value${i + 1}`, randColor(), item);
      });
    } else if (!showInterval) {
      (zipcode?.length ? zipcode : city)?.forEach((item: any, i: number) => {
        createSeries(`value${i + 1}`, randColor(), item);
      });
    } else if (showInterval) {
      [
        `${zipcode[0] ? zipcode[0] : city[0]} High`,
        `${zipcode[0] ? zipcode[0] : city[0]} Low`,
        `${zipcode[0] ? zipcode[0] : city[0]} Mean`,
      ]?.forEach((item: any, i: number) => {
        createSeries(`value${i + 1}`, randColor(), item);
      });
    }

    return () => {
      chartRef.current && chartRef.current?.dispose();
    };
  }, [chartData]);

  return (
    <>
      <div className="chart-main-1">
        <div
          className="chart-main-1__multilineAreaChart"
          id={"chartDiv"}
          ref={chartRef}
        ></div>
        <div className="chart-main-1__cityLegendContainer">
          <div className="chart-main-1__cityLegendContainer__head">
            {title === "Scale"
              ? "Indicators"
              : zipcode?.length
              ? "Zipcode"
              : "City"}
          </div>
          <div className="chart-main-1__cityLegendContainer__cityNameContainer">
            {cities.map((city: any, i: number) => (
              <div
                key={i}
                className="chart-main-1__cityLegendContainer__cityNameContainer__inner"
              >
                <div
                  className="chart-main-1__cityLegendContainer__cityNameContainer__inner__circle"
                  style={{ backgroundColor: city?.color }}
                ></div>
                <div className="chart-main-1__cityLegendContainer__cityNameContainer__inner__text">
                  {city?.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* {title !== "Population" && title !== "Scale" && (
        <div className="chart-main__predictedValueText">
          Predicted values represented by dashed line.{" "}
        </div>
      )} */}
    </>
  );
};

export default Chart;
